import React from "react";

const Image = ({ src, alt }) =>
  src && alt ? <img src={src} alt={alt} /> : null;
export default Image;
